import React from "react";
import * as Icon from "../smartiscity/Icons";
import { handleLogin } from "../utils";
import styled from "styled-components";

const ModalContent = ({ content }) => {
  return (
    <ModalContainer>
      {content.type === "response" && (
        <img
          src={content.status === "success" ? Icon.success : Icon.failure}
          alt="response status icon"
        />
      )}

      {/* <img src={modalType === "success" ? Icon.success : Icon.failure} /> */}
      {content.type === "response" && (
        <ResponseText style={{}}>
          {content.status === "success"
            ? content.version === "user"
              ? "Ο λογαριασμός δημιουργήθηκε με επιτυχία."
              : "Η διαδρομή αποθηκεύτηκε με επιτυχία!"
            : "Κάτι πήγε στραβά. Παρακαλούμε, ξανά δοκιμάστε  αργότερα."}
        </ResponseText>
      )}
      {content.type === "response" &&
        content.version === "user" &&
        content.status === "success" && (
          <NewRouteButton
            type="primary"
            onClick={() => {
              handleLogin();
            }}
          >
            Σύνδεση
          </NewRouteButton>
        )}
    </ModalContainer>
  );
};

export default ModalContent;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-block: 30px;
  justify-content: center;
  align-items: center;
`;

const NewRouteButton = styled.button`
  border-radius: 12px;
  background-color: #27aae1;
  width: fit-content;
  height: fit-content;
  padding: 10px 40px;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.6s ease;

  &:hover {
    background-color: #4bc7fa;
    transition: all 0.6s ease;
  }
`;

const ResponseText = styled.p`
  text-align: center;
  width: 400px;
  margin: 0 auto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5%;
`;
